(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-sell-wizard"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('pssw-form');
  if (!form) return;
  var root = form.closest('.pssw') || form;
  var done = document.getElementById('pssw-done');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); return; }

  var steps = Array.prototype.slice.call(form.querySelectorAll('.pssw__step'));
  if (!steps.length) return;
  var bars = form.querySelectorAll('.pssw__bars span');
  var countEl = form.querySelector('[data-pssw-count]');
  var labelEl = form.querySelector('[data-pssw-label]');
  var cur = 0;

  var val = function (name) { var el = form.querySelector('[name="' + name + '"]:checked'); return el ? el.value : ''; };
  var vals = function (name) { return Array.prototype.map.call(form.querySelectorAll('[name="' + name + '"]:checked'), function (e) { return e.value; }); };
  var field = function (name) { var el = form.querySelector('[name="' + name + '"]'); return el ? el.value.trim() : ''; };
  var types = function () { return vals('pssw_type'); };
  var has = function (t) { return types().indexOf(t) > -1; };
  var isBulk = function () { return has('Bulk'); };
  var onlyBulk = function () { var t = types(); return t.length === 1 && t[0] === 'Bulk'; };
  var hasNonBulk = function () { return types().some(function (t) { return t !== 'Bulk'; }); };
  var onlyGraded = function () { var t = types(); return t.length === 1 && t[0] === 'Graderte kort'; };

  var applyType = function () {
    var bulk = isBulk();
    Array.prototype.forEach.call(form.querySelectorAll('[data-only]'), function (el) {
      var k = el.getAttribute('data-only');
      el.hidden = k === 'bulk' ? !bulk : k === 'notbulk' ? !hasNonBulk() : onlyGraded();
    });
    var lab = form.querySelector('[data-list-label]');
    var opt = form.querySelector('[data-list-opt]');
    var list = form.querySelector('#pssw-list');
    if (onlyBulk()) {
      lab.textContent = 'Noe vi bør vite?';
      opt.textContent = 'Valgfritt — f.eks. sortert eller usortert';
      list.placeholder = 'f.eks. én eske moderne, sortert i holo og non-holo';
    } else if (has('Hel samling')) {
      lab.textContent = 'Fortell litt om samlingen';
      opt.textContent = 'Serier, de beste kortene, permer eller løst';
      list.placeholder = 'f.eks. 4 permer, mest Sun & Moon, noen GX og full art …';
    } else {
      lab.textContent = 'Hvilke kort er det?';
      opt.textContent = 'Kortnavn, serie og nummer';
      list.placeholder = 'f.eks. Charizard ex 199/165 (151), Umbreon VMAX 215/203 …';
    }
    var cash = form.querySelector('[data-pay="cash"]');
    var credit = form.querySelector('[data-pay="credit"]');
    if (cash && credit) {
      if (onlyBulk()) { cash.textContent = 'Fra ' + root.getAttribute('data-bulk-cash') + ' kr/kg'; credit.textContent = 'Fra ' + root.getAttribute('data-bulk-credit') + ' kr/kg'; }
      else { cash.textContent = cash.getAttribute('data-orig'); credit.textContent = credit.getAttribute('data-orig'); }
    }
  };

  var show = function (i) {
    cur = i;
    steps.forEach(function (s, j) { s.hidden = j !== i; s.classList.toggle('is-active', j === i); });
    Array.prototype.forEach.call(bars, function (b, j) { b.classList.toggle('is-on', j <= i); });
    if (countEl) countEl.textContent = 'Steg ' + (i + 1) + ' av ' + steps.length;
    if (labelEl) labelEl.textContent = steps[i].getAttribute('data-label') || '';
    if (i === steps.length - 1) buildSummary();
    var top = form.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    var first = steps[i].querySelector('input:not([type=hidden]),textarea,button');
    if (first && i > 0) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  };

  var check = function (i) {
    var ok = true;
    if (i === 0) ok = types().length > 0;
    if (i === 1) {
      var list = form.querySelector('#pssw-list');
      var needList = hasNonBulk();
      var missing = needList && !list.value.trim() && !field('pssw_link');
      list.classList.toggle('is-invalid', missing);
      if (missing) { list.focus(); ok = false; }
      if (isBulk()) {
        var kg = form.querySelector('#pssw-kg');
        var noKg = !kg.value.trim();
        kg.classList.toggle('is-invalid', noKg);
        if (noKg) { kg.focus(); ok = false; }
      }
    }
    return ok;
  };

  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var collect = function () {
    var bulk = isBulk(), other = hasNonBulk();
    var amount = [];
    if (other) amount.push(val('pssw_count') + ' kort');
    if (bulk) amount.push('Bulk: ' + field('pssw_amount_bulk'));
    return {
      type: types().join(', '),
      lang: other ? val('pssw_lang') : 'Engelsk',
      era: bulk ? (vals('pssw_era').join(', ') || 'Ikke oppgitt') : '',
      amount: amount.join(' · '),
      cond: onlyGraded() ? '' : val('pssw_cond'),
      pay: val('pssw_pay'),
      link: field('pssw_link'),
      list: field('pssw_list')
    };
  };

  var buildSummary = function () {
    var d = collect();
    var rows = [['Type', d.type], ['Språk', d.lang]];
    if (d.era) rows.push(['Serier', d.era]);
    rows.push(['Mengde', d.amount]);
    if (d.cond) rows.push(['Stand', d.cond]);
    rows.push(['Oppgjør', d.pay]);
    if (d.list) rows.push([onlyBulk() ? 'Notat' : 'Kort', d.list]);
    if (d.link) rows.push(['Lenke', d.link]);
    var html = '<dl>' + rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('') + '</dl>';
    form.querySelector('[data-summary]').innerHTML = html;
  };

  form.addEventListener('change', function (e) {
    if (e.target.name === 'pssw_type') {
      applyType();
      var nxt = steps[0].querySelector('[data-next]');
      if (nxt) nxt.disabled = types().length === 0;
    }
  });

  form.addEventListener('click', function (e) {
    var n = e.target.closest('[data-next]');
    var b = e.target.closest('[data-back]');
    if (n) { e.preventDefault(); if (check(cur) && cur < steps.length - 1) show(cur + 1); }
    if (b) { e.preventDefault(); if (cur > 0) show(cur - 1); }
  });

  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && cur < steps.length - 1) {
      e.preventDefault();
      if (check(cur)) show(cur + 1);
    }
  });

  form.addEventListener('submit', function () {
    var d = collect();
    Object.keys(d).forEach(function (k) {
      var out = form.querySelector('[data-out="' + k + '"]');
      if (out) out.value = d[k] || '—';
    });
    Array.prototype.forEach.call(form.querySelectorAll('[name^="pssw_"]'), function (el) { el.disabled = true; });
  });

  if (types().length) { applyType(); steps[0].querySelector('[data-next]').disabled = false; }
  show(0);
})();

  } catch(e) { console.error(e); }
})();
})();
